<template>
    <div v-if="initTime && elapsedTime">
        [ {{ formattedTime }} ]
    </div>
</template>
  
<script>
import { customLogger } from "@/utils";
export default {
    data() {
        return {
            elapsedTime: null,
            timerInterval: null
        };
    },
    props: {
        initTime: {
            type: Number,
            default: 0
        }
    },
    watch: {
        elapsedTime(val, oldVal) {
            this.$store.dispatch('UPDATE_TIME_SPENT');
        }
    },
    computed: {
        formattedTime() {
            const seconds = this.elapsedTime % 60;
            const minutes = Math.floor(this.elapsedTime / 60) % 60;
            const hours = Math.floor(this.elapsedTime / (60 * 60)) % 24;
            const days = Math.floor(this.elapsedTime / (60 * 60 * 24)) % 30;
            const months = Math.floor(this.elapsedTime / (60 * 60 * 24 * 30));

            let formatted = '';
            if (months > 0) {
                formatted += `${this.pad(months, 2)}Month(s)`;
            }
            if (days > 0) {
                formatted += `${this.pad(days, 2)}Day(s) `;
            }
            if (hours > 0) {
                formatted += `${this.pad(hours, 2)}:`;
            }
            formatted += `${this.pad(minutes, 2)}:${this.pad(seconds, 2)}`;

            return formatted.trim();
        }
    },
    methods: {
        startTimer() {
            this.timerInterval = setInterval(() => {
                this.elapsedTime++;
                this.$store.state.user.user_session.total_time_spent++;
            }, 1000);
        },
        pad(number, width) {
            number = number + '';
            return number.length >= width ? number : new Array(width - number.length + 1).join('0') + number;
        }
    },
    created() {
        this.elapsedTime = Math.floor(this.initTime / 1000) 
        this.startTimer();
        // customLogger(this.$store.state.user.user_session);
    },
    destroyed() {
        clearInterval(this.timerInterval);
    }
};
</script>
  